import React, { useState,useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
function OTPPage() {
  const [otp, setOtp] = useState('');
  const [error, setError] = useState('');
  const [infoMessage, setInfoMessage] = useState('');
  const navigate = useNavigate();
  const email = localStorage.getItem('email');  // Retrieve the email from localStorage
  const authToken = localStorage.getItem('authToken');  // Retrieve the auth token from localStorage
  const otpresponse=  localStorage.getItem('otp'); 
  const [resendMessage, setResendMessage] = useState('');
  const [resendLoading, setResendLoading] = useState(false);

  useEffect(() => {
    if (email) {
      setInfoMessage(`Check your email ${email} to get the OTP`);
    }
  }, [email]);

    // useEffect(() => {
    //   // If there is no authToken, redirect the user to SignIn page
    //   if (authToken) {
    //     navigate('/circle-filter');
    //   }
    // }, [authToken, navigate]);
  const handleSubmit = async (e) => {
    e.preventDefault();

    // You would make an API call to verify OTP here and get a token
    try {
      const response = await fetch('https://beta.flowlogic.com/api/users/otp-login/', {
        // const response = await fetch('https://flowmap.uvjtech.in/api/users/otp-login/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, otp }), // Send email and OTP to the API
      });

      const data = await response.json();
      //console.log('Response data:', data);
     // console.log('Access token:',  data.data.token.access);
     
      
      if (response.ok) {
        // Store the token in localStorage if the OTP is correct
           // On successful login, store the tokens (access and refresh)
           console.log('enter Response data:');
           localStorage.setItem('authToken', data.data.token.access);  // Store the access token
           localStorage.setItem('refreshToken', data.data.refresh);  // Optionally, store the refresh token
           setError(data.message);
         
       navigate('/');  // ?Redirect to CircleFilter page after successful OTP verification
           
      //  navigate('/set-password');  // Redirect to CircleFilter page after successful OTP verification
      } else {
        console.log('else Response data:');
        setError(data.message || 'Invalid OTP. Please try again.');  // Show error message if OTP is incorrect
      }
    } catch (err) {
      console.error('Error during fetch:', err);
      setError('Network error, please try again later.',err);
    }
  };

  const handleResendOTP = async () => {
    setResendLoading(true);
    setResendMessage('');
    setError('');

    try {
      const response = await fetch('https://beta.flowlogic.com/api/users/resend-otp/', {
        // const response = await fetch('http://flowmap.uvj.in/api/users/resend-otp/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (response.ok) {
        // setResendMessage(data.message || 'OTP resent successfully. Please check your email.');
        setResendMessage('OTP resent successfully. Please check your email.');
      } else {
        setError(data.message || 'Failed to resend OTP. Please try again.');
      }
    } catch (err) {
      console.error('Resend OTP Error:', err);
      setError('Network error while resending OTP.');
    } finally {
      setResendLoading(false);
    }
  };

  return (
    <div className="signMainInOuter">
    <div className="signInOuter">
    <div className="logo"><img src={"/assets/Flowlogic-Logo.svg"} alt="FlowLogic Icon"  /></div>

          {/* Info Message */}
          {infoMessage && (
          <p style={{ color: 'darkgreen', fontWeight: 'bold', marginBottom: '5px' ,fontSize:'12px'}}>
            {infoMessage}
          </p>
        )}

      <form onSubmit={handleSubmit}>
      <div className="form-group">
        <input
          type="text"
          className="form-control" 
          placeholder="Enter OTP"
          value={otp}
          onChange={(e) => setOtp(e.target.value)}
          required
        />
         </div>
         <Button  variant="success" type="submit" >Verify OTP</Button>
      </form>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      {resendMessage && <p style={{ color: 'green', marginTop: '10px' }}>{resendMessage}</p>}
      <div style={{ marginTop: '20px' }}>
  <span style={{ fontSize: '13px' }}>Didn't get the OTP? </span>
  <span
    onClick={handleResendOTP}
    style={{
      color: 'blue',
      textDecoration: 'underline',
      cursor: resendLoading ? 'not-allowed' : 'pointer',
      fontSize: '13px',
      fontWeight: 'bold',
      opacity: resendLoading ? 0.5 : 1,
      pointerEvents: resendLoading ? 'none' : 'auto'
    }}
  >
    {resendLoading ? 'Resending...' : 'Resend OTP'}
  </span>
</div>

    </div>
    </div>
  );
}

export default OTPPage;
